var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "versand-container" },
    [
      _c(
        "div",
        { staticClass: "versand-header" },
        [
          _vm.canShipToday
            ? [
                _c("div", { staticClass: "h2" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$translate(
                        "Servershop5::Template.newDeldeliveryHeader"
                      )
                    )
                  ),
                ]),
              ]
            : [
                _c("div", { staticClass: "h2" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$translate(
                        "Servershop5::Template.newDeldeliveryHeaderNoShip"
                      )
                    )
                  ),
                ]),
              ],
        ],
        2
      ),
      _vm._v(" "),
      _vm.isTodayIgnored || _vm.canShipToday == false
        ? [
            _vm.isTodayIgnored
              ? [
                  _c("div", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$translate(
                          "Servershop5::Template.newDelnoDeliveryText"
                        )
                      ),
                    },
                  }),
                ]
              : [
                  _c("div", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$translate(
                          "Servershop5::Template.newDelnoDeliveryTextTimeIsOver"
                        )
                      ),
                    },
                  }),
                ],
          ]
        : [
            _c("div", { staticClass: "progress-container" }, [
              _c(
                "div",
                {
                  staticClass: "progress-bar",
                  on: {
                    mouseover: function ($event) {
                      _vm.showTimeMarker = true
                    },
                    mouseleave: function ($event) {
                      return _vm.startTimerHideMarker()
                    },
                  },
                },
                [
                  _c("div", {
                    staticClass: "progress-fill",
                    style: { width: _vm.progressPercentage + "%" },
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.deadlineMarkers, function (option, index) {
                    return _c(
                      "div",
                      {
                        key: "marker-" + index,
                        staticClass: "deadline-marker",
                        style: {
                          left:
                            _vm.calculateDeadlinePosition(option.endtime) + "%",
                        },
                      },
                      [
                        _c("div", {
                          staticClass: "deadline-dot",
                          class: {
                            expired: _vm.isDeadlineExpired(option.endtime),
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "deadline-label" }, [
                          _vm._v(_vm._s(option.endtime)),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "deadline-tooltip",
                            class: {
                              "align-right":
                                _vm.calculateDeadlinePosition(option.endtime) >
                                75,
                            },
                          },
                          [
                            _c("div", { staticClass: "tooltip-title" }, [
                              _vm._v(_vm._s(option.parcelname)),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "tooltip-deadline" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Servershop5::Template.newDeldeliveryDeadline"
                                  )
                                ) +
                                  " " +
                                  _vm._s(option.endtime) +
                                  " " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Servershop5::Template.newDeldeliveryTimeName"
                                    )
                                  )
                              ),
                            ]),
                            _vm._v(" "),
                            !_vm.isDeadlineExpired(option.endtime)
                              ? _c(
                                  "div",
                                  { staticClass: "tooltip-status available" },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$translate(
                                            "Servershop5::Template.newDeldeliveryToday"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "tooltip-remaining" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "Servershop5::Template.newDeldeliveryRemainingTime"
                                            )
                                          ) +
                                            " " +
                                            _vm._s(
                                              _vm.getTimeRemaining(
                                                option.endtime
                                              )
                                            )
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _c(
                                  "div",
                                  { staticClass: "tooltip-status expired" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "tooltip-icon" },
                                      [_vm._v("✗")]
                                    ),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$translate(
                                            "Servershop5::Template.newDeldeliveryDeadlineOver"
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "tooltip-shipping-options" },
                              [
                                _c("div", { staticClass: "tooltip-subtitle" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Servershop5::Template.newDeldeliveryAvailableOptions"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.getAvailableShippingOptionsForDeadline(
                                    option.endtime
                                  ),
                                  function (shippingOption, idx) {
                                    return _c(
                                      "div",
                                      {
                                        key: "option-" + idx,
                                        staticClass: "tooltip-shipping-option",
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(shippingOption.parcelname) +
                                            "\n              "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                _vm._v(" "),
                                _vm.getAvailableShippingOptionsForDeadline(
                                  option.endtime
                                ).length === 0
                                  ? _c(
                                      "div",
                                      { staticClass: "tooltip-no-options" },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$translate(
                                                "Servershop5::Template.newDeldeliveryNoParcelsAvail"
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ]
                        ),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "current-time-marker",
                      class: { visible: _vm.showTimeMarker },
                      style: { left: _vm.progressPercentage + "%" },
                    },
                    [
                      _c("div", { staticClass: "marker-dot" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "marker-label" }, [
                        _vm._v(_vm._s(_vm.formattedCurrentTime)),
                      ]),
                    ]
                  ),
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "progress-time" }, [
                _c("span", { staticClass: "start-time" }, [
                  _vm._v(
                    _vm._s(_vm.startTime) +
                      " " +
                      _vm._s(
                        _vm.$translate(
                          "Servershop5::Template.newDeldeliveryTimeName"
                        )
                      )
                  ),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "end-time" }, [
                  _vm._v(
                    _vm._s(_vm.endTime) +
                      " " +
                      _vm._s(
                        _vm.$translate(
                          "Servershop5::Template.newDeldeliveryTimeName"
                        )
                      )
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "position-relative" },
              _vm._l(_vm.configuredShippingOptions, function (option, index) {
                return _vm.showOption(option)
                  ? _c(
                      "div",
                      {
                        directives: [{ name: "tooltip", rawName: "v-tooltip" }],
                        key: index,
                        staticClass: "shipping-option",
                        attrs: {
                          "data-toggle": "tooltip",
                          "data-placement": "top",
                          title: _vm.getOptionTooltip(option),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.goToLink()
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "option-name" }, [
                          option.logourl
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "option-logo d-inline-block mr-2",
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: option.logourl,
                                      alt: option.parcelname,
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(
                            "\n          " +
                              _vm._s(option.parcelname) +
                              "\n        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "deadline" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(option.endtime) +
                              " " +
                              _vm._s(
                                _vm.$translate(
                                  "Servershop5::Template.newDeldeliveryTimeName"
                                )
                              ) +
                              "\n        "
                          ),
                        ]),
                      ]
                    )
                  : _vm._e()
              }),
              0
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }